<template>
    <div class="jump-warphd nav-bar-fixed">
        <van-nav-bar title="出库单及发货列表" left-arrow fixed
                     @click-left="back"/>
        <van-tabs v-model="tabActive" class="appr-tabs" @click="change">
            <van-list
                    v-model="loading"
                    :finished="finished"
                    finished-text="没有更多了"
                    @load="onLoad">
                <van-tab title="出库单" name="wait">
                    <van-search class="appr-search"
                                v-model="waitValue"
                                @clear="onCancel"
                                show-action>
                        <van-button slot="action" @click="search" size="small" type="info">搜索</van-button>
                    </van-search>
                    <div class="appr-body">
                        <div class="appr-item" v-for="(item, index) in orderlist"
                        >
                            <van-row class="appr-item-head">
                                <van-col span="12" class="appr-item-head-hd">
                                    <!--<span>{{item.id}}</span>-->
                                    <p>{{item.mcmc}}</p>
                                </van-col>
                                <van-col span="12">
                                    <p class="item-r">{{item.createtime}}</p>
                                </van-col>
                            </van-row>
                            <van-row>
                                <van-col span="24">
                                    <!--<a>-->
                                    <p><span>订单编号:</span>{{item.order_number}}{{flowTypeName(item.workFlow_type)}}</p>
                                    <p><span>创建人:</span>{{item.create_user}}</p>
                                    <p><span>确认出库时间:</span>{{item.confirm_time}}</p>
                                    <p><span>发货人:</span>{{item.delivery_user}}</p>
                                    <p><span>发货时间:</span>{{item.delivery_time}}</p>
                                    <p><span>出库单状态:</span>{{item.delivery_goodsorder_status_name}}</p>
                                    <!--</a>-->
                                </van-col>
                                <van-col span="24" class="jump-cart-item-foot">
                                    <!--<van-button size="small" plain class="btn-cancel" v-if="item.orderStatus == 50 || item.orderStatus == 60">查看评价
                                    </van-button>-->


                                    <van-button size="small" plain class="btn-cancel" v-if="item.outLookIsShow"
                                                @click="viewDelivery(item,false,0)"
                                    >
                                        查看详情
                                    </van-button>
                                    <van-button size="small" plain class="btn-cancel" v-if="item.outPaySendIsShow"
                                                @click="viewDelivery(item,true,1)">
                                        扣款发货
                                    </van-button>
                                    <van-button size="small" plain class="btn-cancel" v-if="item.outConfirmationIsShow"
                                                @click="viewDelivery(item,true,2)">
                                        出库确认
                                    </van-button>
                                    <van-button size="small" plain class="btn-cancel" v-if="item.outSendOutIsShow"
                                                @click="viewDelivery(item,true,3)">
                                        发货
                                    </van-button>
                                    <van-button size="small" plain class="btn-cancel" v-if="item.outRMAuditIsShow"
                                                @click="viewDelivery(item,true,7)">
                                        库管审核
                                    </van-button>
                                    <van-button size="small" plain class="btn-cancel" v-if="item.outFMAuditIsShow"
                                                @click="viewDelivery(item,true,6)">
                                        财务审核
                                    </van-button>
                                    <van-button size="small" plain class="btn-cancel" v-if="item.outTMAuditIsShow"
                                                @click="viewDelivery(item,true,7)">
                                        贸易审核
                                    </van-button>


                                    <van-button size="small" plain class="btn-cancel" v-if="item.outBMDeliveryCountIsShow"
                                                @click="viewDelivery(item,true,30)">
                                       填写到货量
                                    </van-button>

                                    <van-button size="small" plain class="btn-cancel" v-if="item.outTMDeductIsShow"
                                                @click="viewDelivery(item,true,31)">
                                        确认扣款
                                    </van-button>

                                    <van-button size="small" plain class="btn-cancel" v-if="item.outCancelIsShow"
                                                @click="viewDelivery(item,true,5)">
                                        取消出库
                                    </van-button>
                                </van-col>
                            </van-row>
                            <van-row class="appr-item-foot">

                            </van-row>
                        </div>
                    </div>
                </van-tab>

                <van-tab title="发货列表" name="already">
                    <van-search class="appr-search"
                                v-model="alreadyValue"
                                @clear="onCancel2"
                                show-action
                    >
                        <van-button slot="action" @click="searcha" size="small" type="info">搜索</van-button>
                    </van-search>
                    <div class="appr-body">
                        <div class="appr-item" v-for="(item, index) in orderAlreadylist"
                             @click="nextpage(index, item.workFlow_id, item)">
                            <van-row class="appr-item-head">
                                <van-col span="24" class="appr-item-head-hd">
                                    <p>订单编号：{{item.orderId}}({{item.workFlow_type==2?'奶牛超市':item.workFlow_type==3?'成品/入库':item.workFlow_type==4?'非入库原料':''}})</p>
                                    <p>牧场名称：{{item.mcmc}}({{item.pastureID}})</p>
                                    <p v-if="item.delivery_goodsorder_status==''">出库单状态：</p>
                                    <p v-if="item.delivery_goodsorder_status=='1'">出库单状态：已创建</p>
                                    <p v-if="item.delivery_goodsorder_status=='2'">出库单状态：已确认出库</p>
                                    <p v-if="item.delivery_goodsorder_status=='3'">出库单状态：已发货</p>
                                    <p v-if="item.delivery_goodsorder_status=='4'">出库单状态：已收货</p>
                                    <p v-if="item.delivery_goodsorder_status=='5'">出库单状态：已取消出库</p>
                                    <p v-if="item.delivery_goodsorder_status=='6'">出库单状态：已扣款</p>
                                    <p>创建人：{{item.create_user}}</p>
                                    <p>创建时间：{{item.createtime}}</p>
                                    <p>确认出库人：{{item.confirm_name}}</p>
                                    <p>确认出库时间：{{item.confirm_time}}</p>
                                </van-col>

                            </van-row>
                            <van-row class="jump-cart-item-foot">
                                <van-button size="small" plain class="btn-cancel" v-if="item.outLookIsShow"
                                            @click="viewDelivery(item,false,1)"
                                >
                                    查看详情
                                </van-button>
                            </van-row>
                        </div>
                    </div>
                </van-tab>
            </van-list>
        </van-tabs>
    </div>
</template>
<script>
    import {NavBar, Cell, CellGroup, Field, Button, Row, Col, Tabs, Tab, Search, List} from "vant";

    export default {
        name: "DeliverList",
        components: {
            [NavBar.name]: NavBar,
            [CellGroup.name]: CellGroup,
            [Cell.name]: Cell,
            [Field.name]: Field,
            [Button.name]: Button,
            [Row.name]: Row,
            [Col.name]: Col,
            [Tabs.name]: Tabs,
            [Tab.name]: Tab,
            [List.name]: List,
            [Search.name]: Search
        },
        data() {
            return {
                tabActive: '',
                activeName: 'wait',
                waitValue: '',
                alreadyValue: '',
                orderlist: [],
                orderAlreadylist: [],
                actionStatus: false,
                loading: false,
                finished: false,
                total: 0,
                url: this.jumuc.userCenter.outboundSingleQueryPage,
                page: 1
            };
        },
        computed: {
            flowTypeName() {
                return function (type) {
                    if (type == 2) {
                        return "（奶牛超市）";
                    } else if (type == 3) {
                        return "（成品/入库）";
                    } else if (type == 4) {
                        return "（非入库原料）";
                    }
                };
            }
        },
        mounted() {
            let that = this;
        },
        methods: {
            back() {
                this.$router.push({path: '/usercent'})
            }, onLoad() {
                let that = this
                // 异步更新数据
                that.$api.post(
                    that.url,
                    {"currentPage": that.page, "pageSize": 10},
                    successRes => {
                        let orderlist = successRes.data.list
                        for (let i = 0; i < orderlist.length; i++) {
                            that.orderlist.push(orderlist[i]);
                            that.orderAlreadylist.push(orderlist[i]);
                        }
                        that.page = successRes.data.pageNum + 1
                        that.total = successRes.data.total
                        // 加载状态结束
                        that.loading = false;
                        // 数据全部加载完成
                        if (that.orderlist.length >= that.total) {
                            that.finished = true;
                        }
                    }
                )

            },
            change(index) {
                let that = this
                if (index == 0) {
                    that.url = this.jumuc.userCenter.outboundSingleQueryPage
                    that. search()
                } else {
                    that.url = this.jumuc.userCenter.deliverGoodsQueryPage
                    that. searcha()
                }

            },
    onCancel (){//出库单
      this.waitValue='';
      this.search();
    },
    onCancel2 (){//发货列表
      this.alreadyValue='';
      this.searcha();
    },

            search() {
                let that = this;
                that.orderlist = []
                that.orderAlreadylist = []
                that.loading = false
                that.finished = false
                that.page = 1
                let seach = ''
                seach = that.waitValue
                this.$api.post(that.url, {"currentPage": that.page, "pageSize": 10, 'orderId': seach},
                    successRes => {
                        that.orderlist = successRes.data.list;
                         that.total = successRes.data.total
                         // 加载状态结束
                        that.loading = false;
                        // 数据全部加载完成
                        if (that.orderlist.length >= that.total) {
                            that.finished = true;
                        }
                    })
            },
            searcha() {
                let that = this;
                that.orderlist = []
                that.orderAlreadylist = []
                that.loading = false
                that.finished = false
                that.page = 1
                let seach = ''
                seach = that.alreadyValue
                this.$api.post(that.url, {"currentPage": that.page, "pageSize": 10, 'orderId': seach},
                    successRes => {
                        that.orderAlreadylist = successRes.data.list;
                         that.total = successRes.data.total
                         // 加载状态结束
                        that.loading = false;
                        // 数据全部加载完成
                        if (that.orderAlreadylist.length >= that.total) {
                            that.finished = true;
                        }
                    })
            },
            nextpage(index, orderid, obj) {
                localStorage.setItem("workflow_id", orderid);
                localStorage.setItem("curdata", JSON.stringify(obj));
                localStorage.setItem("curdataAlready", JSON.stringify(obj));
                localStorage.setItem('actionStatus', this.actionStatus);
                // this.$router.push({path:'/staff/approval/detail/', query: {curdata: obj}})
                this.$router.push({path: '/staff/approval/detail/'})
            },
            viewDelivery(obj, isEdit, id) {
                this.$router.push({
                    path: '/staff/delivery/detail',
                    query: {
                        type: id,
                        isEdit: isEdit,
                        orderId: obj.orderId,
                        outId: obj.outId,
                        workflowId: obj.workFlow_id,
                        status: id
                    }
                });
            },
            deduct() {

            },
        },
    };
</script>
<style lang="less">
    @bule-thame: #3C6EEB;
    body {
        background: #f7f7ff;
    }

    #app .van-tabs__line {
        height: 45px;
        background-color: rgba(255, 255, 255, 0.1);
    }

    .appr-tabs {
        .van-tab {
            color: #fff;
        }
        .van-tabs__nav {
            background-color: @bule-thame;
        }
        .van-hairline--top-bottom::after {
            border-width: 0;
        }
    }

    .jump-cart {


        .van-hairline--bottom::after {
            border-bottom-width: 0px;
        }
        &-body {
            padding: 20px 10px 0;
            position: relative;
            &-hd {
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 80px;
                background-color: @bule-thame;
            }
        }
        &-item {
            background-color: #fff;
            margin-bottom: 15px;
            align-items: center;
            border-radius: 20px;
            padding: 15px;
            position: relative;
            .van-checkbox {
                height: 100%;
                line-height: 100%;
            }
            &-img {
                img {
                    width: 100%;
                }
            }

            h4 {
                font-size: 16px;
                padding: 10px 0;
            }
            &-warp {
                align-self: flex-start;
            }
            p {
                font-size: 16px;
                &.item-time {
                    font-size: 16px;
                    span {
                        float: right;
                        color: @bule-thame;
                    }
                    span.order-cancel {
                        color: green;
                    }
                }
                &.item-price {
                    font-size: 16px;
                    text-align: right;
                }
            }
            &-foot {
                padding: 10px 0;
                text-align: right;
                button {
                    margin-left: 10px;
                    padding: 0 10px;
                    border-radius: 10px;
                    color: #999;
                    border-color: #999;
                }
                button.btn-cancel {
                    color: @bule-thame;
                    border-color: @bule-thame;
                }
            }
        }

    }

    .jump-warphd {
        .appr-search {
            margin-bottom: 10px;
            .van-cell__value {
                border-bottom: 1px #f7f7f7 solid;
            }
            .van-button {
                background-color: @bule-thame;
                border-color: @bule-thame;
            }
        }
        .appr-body {
            padding: 0 10px;
        }
        .appr-item {
            padding: 10px;
            margin-bottom: 10px;
            background-color: #fff;

            p {
                padding: 4px 0;
                font-size: 14px;
                &.item-r {
                    color: #ccc;
                    text-align: right;
                }
                span {
                    min-width: 60px;
                    display: inline-block;
                }
            }
            &-head {
                border-bottom: 1px #f7f7f7 solid;
                &-hd {
                    position: relative;
                    /*padding-left: 40px;*/
                    span {
                        position: absolute;
                        top: 0;
                        left: -15px;
                        padding: 0 8px;
                        color: #fff;
                        background-color: @bule-thame;
                        font-size: 14px;
                        border-radius: 0 10px 10px 0;
                    }
                }
            }
            &-foot {
                border-top: 1px #f7f7f7 solid;
                p {
                    color: #ccc
                }
            }
        }
    }
</style>
